import '../../../rubberduck/dist/js/import-jquery-light.js';
import { LazyLoad } from '../../../rubberduck/dist/lib/rubberduck/LazyLoad.js';
import { backgroundSetter } from '../../../rubberduck/dist/lib/rubberduck/backgroundSetter/backgroundSetter.js';
import { EventCalendarHandler } from '../../../../app/src/rubberduck/event/src/Event/dist/js/EventCalendarHandler.js';
import { GDPRHandler } from '../../../../app/src/rubberduck/core/src/GDPR/dist/js/GDPRHandler.js';
import { QuackFormHandler } from '../../../../app/src/rubberduck/cms/src/Form/dist/QuackFormHandler.js';
import { PropertyHandler } from '../../../../app/src/rubberduck/property/dist/js/PropertyHandler.js';
import { Pagination } from '../../../rubberduck/dist/lib/rubberduck/pagination/pagination2.build.js';
import { getTranslation, viewport } from '../../../rubberduck/dist/js/utils.js';
import Swup from 'swup';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupGaPlugin from '@swup/ga-plugin';
import SwupGtmPlugin from '@swup/gtm-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import SwupOverlayTheme from '@swup/overlay-theme';

require('is-in-viewport/lib/isInViewport.min.js');

var $html = $('html');
var $body = window.$body = $('body');
var $nav = $('.nav');
var $menu = $('.menu');
var $content = $('.content');

var bgSetter = null;
var ajax_lock = false;
var maps = [];

var lang = $html.attr('lang');

var swup;
var $swup_status = $('.swup-status');

var $pagination;

var payment_form;

let propertyHandler;

const lazyLoader = new LazyLoad();
lazyLoader.default();

// SWUP
if (!isIE()) {
    if (swup == undefined) {
        var ga_measurement_id = null;
        let containers = ['#main', '#recaptcha_script', '.top__lang'];
        let swup_containers = []
        for (let i = 0; i < containers.length; i++) {
            const e = containers[i];
            if ($(e).length > 0) swup_containers.push(e);
        }
        if (google_credentials.analytics.measurement_id !== "") {
            ga_measurement_id = google_credentials.analytics.measurement_id;
        }
        var swup_plugins = [
            new SwupScriptsPlugin({
                head: false,
                body: true,
            }),
            new SwupOverlayTheme({
                color: '#FFF',
                duration: 500,
                direction: 'to-bottom',
            }),
            new SwupHeadPlugin()
        ];
        if (google_credentials.analytics.active) {
            swup_plugins.push(
                new SwupGaPlugin({
                    gaMeasurementId: ga_measurement_id
                })
            );
        }
        if (google_credentials.tag_manager.active) {
            swup_plugins.push(new SwupGtmPlugin());
        }
        swup = new Swup({
            containers: swup_containers,
            cache: false,
            linkSelector: 'a[href^="' +
                window.location.origin +
                '"]:not([data-no-swup]):not([target="_blank"]):not([data-fancybox]):not([class*="ui-datepicker])',
            animateHistoryBrowsing: true,
            skipPopStateHandling: function () {
                return false;
            },
            plugins: swup_plugins
        });

        // Swup events
        swup.hooks.on('content:replace', function() {
            onLoad();
            swupStatusChange(getTranslation('cms_general', 'page_loaded'));
        });
        swup.hooks.on('animation:out:start', reset);
        swup.hooks.on('animation:out:end', destroy);
        swup.hooks.on('animation:in:end', function() {
            $(window).trigger('resize');
        });
        swup.hooks.on('link:self', function () {
            if (!$body.hasClass('menu--shown')) {
                scrollPage('#main');
            } else {
                toggleBurgerMenu();
            }
        });
    }
} else {
    if (isIE()) {
        $('.popup[data-popup="update-browser"]').fadeIn(1000);
    }
    $html.removeClass('is-animating');
}
// Fade out content on page refresh
window.onbeforeunload = function (e) {
    if (
        typeof e.target.activeElement.href === 'undefined' ||
        e.target.activeElement.href.indexOf('tel:') == -1 &&
        e.target.activeElement.href.indexOf('mailto:') == -1
    ) {
        // Only when it is not a phone or mail link
        $html.addClass('is-animating');
        reset();
    }
}

function swupStatusChange(string) {
    $swup_status.fadeOut(125, function () {
        $swup_status.html(string).fadeIn(125);
    });
}

function onLoad() {
    $content = $('.content');

    // Google map on page reentry
    if (typeof initMap !== 'undefined') initMaps();

    // GDPR
    if (typeof GDPRHandler != 'undefined') {
        let gdpr = new GDPRHandler();
        gdpr.init();
    }

    if (typeof backgroundSetter === "function") {
        bgSetter = new backgroundSetter();
        bgSetter.init();
    }

    $('#main > .content .section:not(.fullBG):not(.fullBGfix)').each(function(index, section) {
        if ($(section).css('background-color') == $(section).next('.section:not(.fullBG):not(.fullBGfix)').css('background-color')) {
            $(section).next('.section:not(.fullBG):not(.fullBGfix)').find('> .padd').addClass('padd--bottom');
        }
    });
    // if ($('#main > .content > .section:first-child:not(.fullBG):not(.fullBGfix)').css('background-color') == $('body').css('background-color')) {
    //     $('#main > .content > .section:first-child:not(.fullBG):not(.fullBGfix)').find('> .padd').addClass('padd--bottom');
    // }

    // MENU AUTO ACTIVE STATE
    let currentURL = window.location.href;
    let $nav_links = $('a', $nav);
    let $menu_links = $('a', $menu);
    let $footer_links = $('a', $('footer'));
    let $all_links = $nav_links.add($menu_links).add($footer_links);

    // Nav and menu links
    for (let i = 0; i < $all_links.length; i++) {
        const $el = $all_links.eq(i).removeClass('active');
        if (currentURL == $el.attr('href')) {
            setTimeout(function () {
                $el.addClass('active');
            }, 10)
        }
    }

    ///////////////////////////////////////////////////////////////////////////
    // FORMS DATEPICKERS
    ///////////////////////////////////////////////////////////////////////////
    $('.form_datepicker').datepicker({
        beforeShow: function (input, inst) {
            inst.dpDiv.css({
                marginLeft: input.offsetWidth + 'px'
            });
            var classArr = $(input).closest('.section').attr('class').split(/\s+/);
            $.each(classArr, function(index, value){
                if (value.startsWith('RM')) inst.dpDiv.addClass(value + '-ui-datepicker');
            });
        }
    });
    ///////////////////////////////////////////////////////////////////////////
    // SELECT2
    ///////////////////////////////////////////////////////////////////////////
    let select2_options = {
        debug: true,
        width: '100%',
        minimumResultsForSearch: Infinity, // Hide the search input
        theme: '',
        language: lang
    }
    $selects = $('select');

    for (let i = 0; i < $selects.length; i++) {
        let $el = $selects.eq(i);
        select2_options.dropdownParent = $el.parent();
        $el.select2(select2_options)
            .on('select2:open', function (e) {
                // Search
                $('.select2-search__field').attr('placeholder', (lang == 'fr' ? 'Recherche' : 'Search'));

                let $dropdown = $('.select2-dropdown');
                $dropdown.hide();
                setTimeout(function () {
                    $dropdown.slideDown(250);
                }, 10);
            });
    }


    ///////////////////////////////////////////////////////////////////////////
    // FILE INPUTS
    ///////////////////////////////////////////////////////////////////////////
    $file_inputs = $('.input--file input[type="file"]');
    $file_inputs.on('change', function () {
        let $this = $(this);
        let $display = $this.next();

        if ($this.val() != '') {
            $display.addClass('not-empty');
            $display.children('.input__path').clearQueue().stop().fadeOut(250);
            setTimeout(function () {
                $display.children('.input__path').html($this.val().replace('C:\\fakepath\\', '')).fadeIn(250);
            }, 250);
        } else {
            $display.removeClass('not-empty');
            $display.children('.input__path').clearQueue().stop().fadeOut(250);
            setTimeout(function () {
                $display.children('.input__path').html($this.attr('placeholder')).fadeIn(250);
            }, 250);
        }
    }).trigger('change');
    $('.input__clear').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.input--file').find('input[type="file"]').val('').trigger('change');
    });

    $('.clear-form').on('click', function () {
        clearForm($(this).closest('form').parent());
    });

    ///////////////////////////////////////////////////////////////////////////
    // SLICK
    ///////////////////////////////////////////////////////////////////////////
    if ($('.slick--RGO07').length) {
        $('.slick--RGO07').each(function () {
            let RGO07_slides = $(this).children('.slide').length;
            let slides_to_show = 3;
            // if (RGO07_slides <= 3) {
            //     slides_to_show = RGO07_slides;
            // }

            $(this).slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: slides_to_show,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: false,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                // waitForAnimate: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1281,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ],
                rows: 0
            });
        });
    }
    if ($('.slick--featured').length) {
        $('.slick--featured').slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            rows: 0
        });
    }
    if($('.slick--RMO03').length) {
        $('.slick--RMO03').slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            rows: 0
        });
    }

/*
    if ($('.slick--gallery').length) {
        $('.slick--gallery').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1000,
            fade: true,
            centerMode: true,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            rows: 0
        });
    }

*/


    if ($('.slick--gallery:not(.slick--gallery-configurable)').length) {

        $('.slick--gallery:not(.slick--gallery-configurable)').each(function () {    
            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: true,
                centerMode: true,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                rows: 0
        })
    
        });
    }


 
    $('.slick--gallery.slick--gallery-configurable').each(function () {

        const $slider = $(this);
       if ($slider.hasClass('slick-initialized')) return; 
        let interval = Number($slider.data('interval'));
        let autoplay = !!interval && interval > 0;

        let transitionSpeed = 1000; // durée du fade/slide en ms
        // Ajouter le temps de transition au délai pour éviter le glitch
        let autoplaySpeed = autoplay ? (interval + transitionSpeed) : 1000;

        $slider.slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: transitionSpeed,
            fade: true,
            centerMode: true,
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: true,
            rows: 0
   
        
        });
       
    
    });

/*
$('.slick--gallery.slick--gallery-configurable').each(function () { 
    const $slider = $(this); 
    if ($slider.hasClass('slick-initialized')) return; 
    
    let interval = Number($slider.attr('data-interval')) || 0; 
    let autoplay = !!interval && interval > 0;
    let intervalId = null;
    
    $slider.slick({ 
        dots: true,
        arrows: true,
        infinite: true,
        speed: 1000,
        fade: true,
        centerMode: false, 
        autoplay: autoplay,
        autoplaySpeed: interval, 
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnFocus: true,   // Stop au focus
        pauseOnHover: true,   // Stop au survol
        draggable: true,
        swipe: true,
        swipeToSlide: true,
        waitForAnimate: false,
        rows: 0
    }); 
    
    if (autoplay) {
        function play() {
            if (!intervalId) {
                intervalId = setInterval(() => { 
                    if (!$slider.hasClass('slick-animating')) {
                        $slider.slick('slickNext'); 
                    }
                }, interval);
            }
        }
        
        function pause() {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        }
        
        play();
        
        // Pause au survol
        $slider.hover(pause, play);
        
        // Pause au focus (clic)
        $slider.focusin(pause);
        $slider.focusout(play);
    }
});
*/




    if ($('.slick--RMO19').length) {
        $('.slick--RMO19').slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 4,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            responsive: [
                {
                    breakpoint: 1601,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 901,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 481,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            rows: 0
        });
    }
    if ($('.RGO14 .schedule').length) {
        $('.RGO14 .schedule').slick({
            infinite: false,
            slidesToShow: 7,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 2000,
            draggable: false,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        draggable: true,
                        slidesToShow: 4
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,

                    },
                },
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 2,

                    },
                }
            ],
            rows: 0
        });
    }
    if ($('.slick--RGO21').length) {
        $('.slick--RGO21').each(function () {
            $(this).slick({
                dots: true,
                arrows: false,
                infinite: false,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: false,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                focusOnSelect: true,
                rows: 0
            });
        });
    }
    ///////////////////////////////////////////////////////////////////////////
    // Give cards same height
    ///////////////////////////////////////////////////////////////////////////

    giveCardsSameHeight();

    
    ///////////////////////////////////////////////////////////////////////////
    // ICEBERG
    ///////////////////////////////////////////////////////////////////////////
    $body.on('click', '.iceberg__head a', function (e) {
        e.stopPropagation();
    });
    $body.on('click', '.iceberg__head', function (e) {
        let $this = $(this);
        // Slide toggle clicked iceberg
        $this.toggleClass('active')
            .next('.iceberg__body').stop().slideToggle(350);
    });
    $('.iceberg__head.active').next().show();


    ///////////////////////////////////////////////////////////////////////////
    // RMO01
    ///////////////////////////////////////////////////////////////////////////
    if ($('.RMO01').length > 0) {

        $('.filter', $('.RMO01')).on('click', function() {
            let categ = $(this).attr('data-filter');
            let $section = $(this).closest('.section');

            $(this).toggleClass('active').siblings().removeClass('active');

            if ($(this).hasClass('active')) {
                $section.find('.iceberg-category').stop().slideUp(350)
                    .filter('.' + categ).stop().slideDown(350, function() {
                        $(this).css('height', '');
                        $(window).trigger('scroll');
                    });
            } else {
                $section.find('.iceberg-category').stop().slideDown(350, function() {
                    $(this).attr('style', '');
                    $(window).trigger('scroll');
                });
            }

        });
    }


    ///////////////////////////////////////////////////////////////////////////
    // SHOP
    ///////////////////////////////////////////////////////////////////////////
    function updatePagination(data) {
        if (data.additional_html) {
            if (data.additional_html.tags) {
                let html = '';
                html = data.additional_html.tags;
                if ($('#tags').length) {
                    $('#tags').html(html);
                    $('#tags .iceberg__head.active').next().show();
                }
            }
            if (data.additional_html.info_windows) {
                if (typeof propertyHandler != 'undefined') {
                    propertyHandler.setMapData(data.additional_html.info_windows);
                }
            }
        }
    }
    window['updatePagination'] = updatePagination;

    $body.on('change', '.filter_sub [type="checkbox"], .filter_sub [type="radio"]', function (e) {
        let filter = true;
        let container = $(this).closest('.filter_container');
        container.find('input:not(:checked)').parents('li').removeClass('active');
        if ($(this).val() == '') {
            container.find('input').prop('checked', false);
            container.find('.active').removeClass('active');
            $(this).parents('li').addClass('active');
        } else {
            if ($(this).prop('checked')) {
                $(this).parents('li').addClass('active');
                if ($(this).hasClass('view_all')) {
                    $(this).closest('li').siblings().removeClass('active').find('input').prop('checked', false);
                } else {
                    $(this).closest('ul').find('input.view_all').prop('checked', false).closest('li').removeClass('active');
                }
            } else {
                $(this).parents('li').removeClass('active');
                if ($('[name="' + $(this).attr('name') + '"]:checked').length == 0) {
                    container.find('.filter_sub label').first().trigger('click');
                    filter = false;
                }
            }
        }
        if (filter) {
            filterPagination();
        }
    });

    $body.on('click', '.reset_filters', function (e) {
        e.preventDefault();
        let container = $(this).closest('.filter_container');
        // Uncheck all
        container.find('.filter_sub [type="checkbox"], .filter_sub [type="radio"]').prop('checked', false).parents('li.active').removeClass('active');
        container.find('.filter_sub select').addClass('no_trigger').val('').trigger('change').removeClass('no_trigger');
        container.find('.filter_sub [type="text"], .filter_sub [type="search"]').val('');
        // Check "View All"
        container.find('.filter-iceberg .filter_container > ul > .filter_sub:first-child').addClass('active');
        filterPagination();
    });

    $body.on('change', '.filter_sub select:not(.no_trigger)', function () {
        filterPagination();
    });


    $body.on('click', '.trigger-layout', function () {
        let $this = $(this);
        let $grid = $(this).closest('.section').find('.grid');
        $grid.stop().fadeOut(250, function () {
            $(this).toggleClass('layout--list').fadeIn(500);
            $('.trigger-layout').toggleClass('active');
        });
    });

    $body.on('click', '.dropdown__drop li', function () {
        let sort = $(this).attr('data-sort');
        let label = $(this).text();

        let filter = $(this).closest('.dropdown').find('.dropdown__current');
        filter.find('.label .value').text(label);
        filter.find('input').val(sort);
        filterPagination();
        $(this).blur();
    });

    $body.on('keypress', '.filter_sub [type="search"]', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            filterPagination();
        }
    });
    $body.on('click', '.filter_sub button.search', function (e) {
        e.preventDefault();
        filterPagination();
    });
    $body.on('click', '.trigger_pagination', function (e) {
        e.preventDefault();
        filterPagination();
    });


    ///////////////////////////////////////////////////////////////////////////
    // MIXITUP
    ///////////////////////////////////////////////////////////////////////////
    function handleResetFiltersVisiblity() {
        $('.reset_filters').each(function() {
            let hide = true;
            let btn = $(this);
            let inputs = btn.closest('form').find('input:not([type="hidden"]), select');
            inputs.each(function(index, input) {
                if (hide) hide = ($(input).val() == '');
                if (index == (inputs.length - 1)) btn.toggleClass('hide_reset', hide);
            });
        });
    }
    function filterPagination() {
        if ($('.pagination_wrapper').length > 0) {
            if ($pagination.htmlWrapper.length > 0 && $pagination.htmlContentWrapper.length > 0) {
                $pagination.fetchAjaxInformationPagination(
                    false,// UPDATE: Si le nombre maximum d’élément change, le script à besoin de savoir si on update les éléments (true) ou on les remplaces (false).
                    true, // KEEP_NB_SELECT: Est-ce que le nombre d’éléments affichés par pages reste le même ou non.
                    false // RESET: Si on doit simplement remettre la pagination à la première page en gardant le nombre d’éléments affichés par pages.
                );
                handleResetFiltersVisiblity();
            }
        }
    }

    if ($('.mixitup').length) {
        var mixitup = require('mixitup');
        var mixitupMultifilter = require('../lib/mixitup/mixitup-multifilter.min.cjs');
        mixitup.use(mixitupMultifilter);
        var mixit = mixitup('.filtered:not(.pagination_content_wrapper)', {
            selectors: {
                target: '.filtered_items',
                control: '.mixitup li'
            },
            multifilter: {
                enable: true
            },
            animation: {
                queueLimit: 5
            },
            callbacks: {
                onMixClick: function(state, originalEvent) {
                    $(state.container).closest('.section').find('.mixitup .filter_container .searchbar input').val('');
                }
            }
        });
        const delay = (function(){
            var timer = 0;
            return function(callback, ms){
                clearTimeout (timer);
                timer = setTimeout(callback, ms);
            }
        })();
        var mixitupContainer, mixitupItems, mixitupSearchInputText;
        $body.on('input', '.mixitup.filters .filter_container .searchbar input', function() {
            mixitupSearchInputText = $(this).val().toLowerCase();
            mixitupContainer = $(this).closest('.section');
            mixitupItems = mixitupContainer.find('.filtered .filtered_items');
            // Delay function invoked to make sure user stopped typing
            delay(function(){
                // Reset category to 'all'
                let filter = mixitupContainer.find('.desktop_categories [data-filter].active');
                if (filter.length) {
                    filter.removeClass('active');
                    filter.find('input').prop('checked', false);
                    mixitupContainer.find('.desktop_categories [data-filter="all"]').addClass('active').find('input').prop('checked', true);
                }
                var matching = $();
                // Check to see if input field is empty
                if ((mixitupSearchInputText.length) > 0) {            
                    mixitupItems.each(function() {
                        // add item to be filtered out if input text matches items inside the title   
                        if ($(this).text().toLowerCase().match(mixitupSearchInputText)) {
                            matching = matching.add(this);
                        } else {
                            // removes any previously matched item
                            matching = matching.not(this);
                        }
                    });
                    mixit.filter(matching);
                } else {
                    // resets the filter to show all item if input is empty
                    mixit.filter('all');
                }
            }, 200);
        });

        $('.filtered:not(.pagination_content_wrapper)').on('mixEnd', function () {
            $(window).trigger('resize');
        });
        $('.filtered:not(.pagination_content_wrapper)').on('mixEnd', function () {
            $(window).trigger('resize');
        });
    }

    // MIXITUP LI GET ACTIVE CLASS ON CLICK
    let categoriesArr = $('.desktop_categories li');

    categoriesArr.each(function () {
        let radio = $(this).find('input[type="radio"]');
        radio.on('change', function () {
            if (radio.prop('checked') == true) {
                categoriesArr.removeClass('active');
                $(this).closest('li').addClass('active');
            } else {
                $(this).removeClass('active');
            }
        })
    })

    // MIXITUP TAGS GET ACTIVE ON CLICK
    let tagsCheckboxes = $('.filters-tags input[type="checkbox"]');
    tagsCheckboxes.each(function () {
        $(this).on('change', function () {
            if ($(this).is(':checked') == true) {
                $(this).closest('li').addClass('active');
            } else {
                $(this).closest('li').removeClass('active');
            }
            filterPagination();
        })
    })

    $('.tags--reset').on('click', function(){
        $('.filter_container *').removeClass('active');
    })
    

    // mixitup tags hide
    //category
    $('.cat-plus-btn').on('click', function(){
        $(this).toggleClass('closed');
        $('.desktop_categories').slideToggle();
    })
    $('.tag-plus-btn').on('click', function () {
        $(this).toggleClass('closed');
        $('.filters-tags').slideToggle();
    })

    // Filters sidebar
    $body.on('click', '.open-filters', function () {
        $body.toggleClass('filters--shown');
    });
    $body.on('click', '.close-filters', function () {
        $body.removeClass('filters--shown');
    });


    ///////////////////////////////////////////////////////////////////////////
    // VIDEO RGO02 / RGO07 / RGO08 / RMO24 Mourad
    ///////////////////////////////////////////////////////////////////////////
    if ($('.RGO02-A, .RGO02-B, .RGO03, .RGO07, .RGO08, .RMF37-A, .RMF37-B, .RMF39, .RMO24, .RGO01-A.split').length) {
        $videos = $('video', $('.RGO02-A, .RGO02-B, .RGO03, .RGO07, .RGO08, .RMF37-A, .RMF37-B, .RMF39, .RMO24, .RGO01-A.split'));
        $videos.on('click', function () {
            if(!$(this)[0].paused) {
                $(this).trigger('pause');
            } else {
                $(this).trigger('play');
            }
        })
        .on('pause ended', function() {
            $(this).removeClass('active').next().stop().fadeIn();
            $(this).closest('section').find('.image__title').removeClass('hidden');
            $(this).closest('section').find('.image__credit').removeClass('hidden');
        }).on('play', function() {
            $(this).addClass('active').next().stop().fadeOut();
            $(this).closest('section').find('.image__title').addClass('hidden');
            $(this).closest('section').find('.image__credit').addClass('hidden');
        });
    }

    ///////////////////////////////////////////////////////////////////////////
    // RMF09 / RMF16
    ///////////////////////////////////////////////////////////////////////////
    if ($('.RMF19').length) {
        if ($('.RMF36').length <= 0) {
            $('.RMF19 .btn-container').hide();
        }
    }

    // JQUERYUI DATEPICKER
    function setDatepicker(target) {
        let $datepicker = $(target);
        $datepicker.each(function () {
            let $this = $(this);
            $this.datepicker({
                showOtherMonths: true,
                selectOtherMonths: true,
                altField: "#datepicker",
                closeText: 'Fermer',
                // prevText: 'Précédent',
                // nextText: 'Suivant',
                currentText: 'Aujourd\'hui',
                // monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                // monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
                // dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                // dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
                // dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
                // weekHeader: 'Sem.',
                dateFormat: ($this.attr('data-format') ? $this.attr('data-format') : 'dd-mm-yy'),
            });

            if ($this.attr('data-min-date') != null) {
                let min_date = $this.attr('data-min-date');
                $this.datepicker('option', 'minDate', min_date);
            }

            if ($this.attr('data-max-date') != null) {
                let max_date = $this.attr('data-max-date');
                $this.datepicker('option', 'maxDate', max_date);
            }
        });
    }
    setDatepicker('.datepicker:not(.booking_picker)');
    
    // CALENDAR
    if (typeof EventCalendarHandler != 'undefined') {
        calendar_handler = new EventCalendarHandler();
        calendar_handler.init();
    }

    // PROPERTY
    if (typeof PropertyHandler != 'undefined') {
        propertyHandler = new PropertyHandler();
    }
    if ($('.slick--RMO10').length) {
        $('.slick--RMO10').each(function () {
            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: 3,
                slidesToScroll: 3,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 551,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 2
                        }
                    }
                ]
            });
        });
    }
    // RMF08
    if ($('.RMF08').length) {
        function handleThumbnailsHeight() {
            let thumbnails = $('.RMF08 .gallery--thumbnails .slick-slide .img');
            thumbnails.outerHeight(0);
            let height = $('.RMF08 .listing').outerHeight();
            let count = $('.RMF08 .gallery--thumbnails .slick-slide.slick-active').length;
            let spacing = parseFloat($('.RMF08 .gallery--thumbnails .slick-slide').css('marginTop')) * 2;
            let imgHeight = (height - (spacing * count)) / count;
            thumbnails.outerHeight(imgHeight);
        }
        if ($('.RMF08 .gallery').length) {
            $('.RMF08 .gallery .gallery--main').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 750,
                fade: true,
                centerMode: false,
                autoplay: false,
                autoplaySpeed: 4000,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                waitForAnimate: false,
                adaptiveHeight: true,
                asNavFor: '.RMF08 .gallery .gallery--thumbnails',
                rows: 0
            });
            $('.RMF08 .gallery .gallery--thumbnails').slick({
                dots: false,
                arrows: false,
                infinite: true,
                vertical: true,
                verticalSwiping: true,
                speed: 750,
                centerMode: false,
                autoplay: false,
                autoplaySpeed: 4000,
                slidesToShow: 4,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: true,
                waitForAnimate: false,
                focusOnSelect: true,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                asNavFor: '.RMF08 .gallery .gallery--main',
                responsive: [
                    {
                        breakpoint: 550,
                        settings: {
                            slidesToShow: 4,
                            vertical: false,
                            verticalSwiping: false,
                            draggable: true,
                            swipeToSlide: true
                        }
                    }
                ],
                rows: 0
            });
        }
        $('body').on('click', '.specifications .specifications_menu .specification', function () {
            $('.specifications .specifications_menu .specification.active').removeClass('active');
            $(this).addClass('active');
            let data_menu = $(this).data('menu');
            // show matching content
            $('.specification_content').each(function () {
                if ($(this).data('menu') == data_menu) {
                    $(this).slideDown();
                } else {
                    $(this).slideUp();
                }
            })
        });
        $('body').on('change', '.specifications .specifications_menu select', function () {
            let value = $(this).val();
            $('.specification_content').each(function () {
                if ($(this).data('menu') == value) {
                    $(this).slideDown();
                } else {
                    $(this).slideUp();
                }
            })
        });
        $('body').on('click', '.quantity .plus', function () {
            let input = $(this).closest('.quantity').siblings('input[type="number"]');
            let inputVal = input.val();
            var plus = '';

            if (isNaN(inputVal) || input.val() == "") {
                plus = 0 + 1;
            } else {
                plus = parseInt(inputVal) + 1;
            }
            input.val(plus);
        });
        $('body').on('click', '.quantity .minus', function () {
            let input = $(this).closest('.quantity').siblings('input[type="number"]');
            let minus = parseInt(input.val()) - 1;
            if (minus >= 0) {
                input.val(minus);
            } else {
                input.val(0);
            }
        });
        $('body').on('click', '.mortgage_trigger', function (e) {
            const isActive = $('#mortgage').hasClass('active');
            $('#mortgage').toggleClass('active');
            $('body').toggleClass('no-scroll');
            if (!isActive) {
                const isScrolled = $('body').hasClass('scroll');
                if (isScrolled) $('body').addClass('wasScrolled');
                $('body').addClass('scroll');
            } else {
                $('body').toggleClass('scroll', $('body').hasClass('wasScrolled'));
                $('body').removeClass('wasScrolled');
            }
        });
        $(window).on('resize', $.throttle(100, handleThumbnailsHeight));
    }
    
    ///////////////////////////////////////////////////////////////////////////
    // PAGINATION
    ///////////////////////////////////////////////////////////////////////////
    if ($('.pagination_wrapper').length > 0) {
        let number_per_page = 24;
        let current_page = 1;
        let params = window.location.search.substr(1).split('&');
        if (params.length > 0) {
            for (let i = 0; i < params.length; i++) {
                let pair = params[i].split('=');
                let key = pair[0];
                if (key == 'number_items') {
                    number_per_page = parseInt(pair[1]);
                }
                if (key == 'page') {
                    current_page = parseInt(pair[1]);
                }
            }
        }
        $pagination = new Pagination({
            display_go_to: false,
            size_list: 'mini',
            number_items_per_page: number_per_page,
            call_back_return: 'updatePagination'
        });

        $pagination.currentPage = current_page;
        filterPagination();


        // Filter buttons as labels
        $body.on('click', 'input + button.filter', function() {
            $(this).prev('input').prop('checked', !$(this).prev('input').prop('checked'));
            filterPagination();
        });
    }

    ///////////////////////////////////////////////////////////////////////////
    // COPY URL
    ///////////////////////////////////////////////////////////////////////////
    $body.on('click', '.copy_url', function () {
        copyTextToClipboard(window.location.href);
        $('.message_copied').slideDown().delay(1000).slideUp();
    });
    function fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }

    function copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function () {
            console.log('Async: Copying to clipboard was successful!');
        }, function (err) {
            console.error('Async: Could not copy text: ', err);
        });
    }


    ///////////////////////////////////////////////////////////////////////////
    // RECAPTCHA
    ///////////////////////////////////////////////////////////////////////////
    let form_handler = new QuackFormHandler({
        ajax_selector: 'form:not(.no_ajax):not(.custom_ajax):not(.filter_container)',
        no_ajax_selector: 'form.no_ajax'
    });


    ///////////////////////////////////////////////////////////////////////////
    // VIDEO Mourad
    ///////////////////////////////////////////////////////////////////////////
    // Video controls
    /*
    $body.on('click', '.video__play', function () {
        togglePlayMedia($(this).closest('.section').find('video')[0]);
    });
    $body.on('click', '.video__volume', function () {
        toggleSoundMedia($(this).closest('.section').find('video')[0]);
    });
*/

    $body.on('click', '.video__play', function () {

        const video = $(this).closest('.section').find('video')[0];
        if (!video) return;
        togglePlayMedia(video);
    });
    $body.on('click', '.video__volume', function () {
        const video = $(this).closest('.section').find('video')[0];
        if (!video) return;

        toggleSoundMedia(video);
    });
    ///////////////////////////////////////////////////////////////////////////
    // RGO18 (Alert)
    ///////////////////////////////////////////////////////////////////////////
    if ($('.RGO18').length) {
        $body.on('click', '.RGO18 button', function () {
            $(this).closest('.RGO18').slideUp(function () {
                $(this).remove();
            });
        });
    }

    ///////////////////////////////////////////////////////////////////////////
    // SCROLL ARROW
    ///////////////////////////////////////////////////////////////////////////
    $(".page-scroll").on('click', function () {
        var targetDiv = $(this).attr('href') || $(this).data('target');
        // if (targetDiv) targetDiv = $(this).data('target');

        scrollPage(targetDiv, 80);

        return false;
    });

    // Scrolled to hash on load (no animation)
    if (window.location.hash != '') {
        window.scrollTo(0, $(window.location.hash).offset().top - $nav.height());
    }

    $(window).trigger('resize');

    ///////////////////////////////////////////////////////////////////////////
    // RMO09 REMOVE POSTULER BUTTON
    ///////////////////////////////////////////////////////////////////////////
    if($('.RMF09').length){
        if($('.RMF35').length === 0) {
            $('.apply-btn').css('display', 'none');
        }
    }
}
// onLoad()


function reset() {
    swupStatusChange(getTranslation('cms_general', 'loading_page'));
    // Remove event listeners
    $content.off();
    // Reset menu state
    $body.off().removeClass();
} // reset()
function destroy() {
    window.scrollTo(0, 0);
    // Destroy select2
    $('select').select2('destroy');
    // Destroy slicks
    $('.slick-initialized').slick('unslick');
    // Destroy maps
    if (maps.length > 0) {
        for (let i = 0; i < maps.length; i++) {
            maps[i].remove();
        }
        maps = [];
    };
} // destroy()

////////////////////////////////////////////////////////////////////////////////

function giveSizeToOthers($context, $toResize, minWidth, maxWidth) {
    if ($context.length > 0) {
        if ($toResize.length > 0) {
            if (!minWidth) var minWidth = 0; // compatibilité IE
            if (!maxWidth) var maxWidth = 9999; // compatibilité IE
            if (viewport().width > minWidth && viewport().width < maxWidth) {
                $context.each(function () {
                    var height = 0;
                    var $objects = $(this).find('.' + $toResize.attr("class").split(' ')[0]);
                    $objects.each(function () {
                        if ($(this).is(':visible')) {
                            $objects.height('');
                            var currentHeight = $(this).children('.resize').outerHeight();
                            if (currentHeight > height) height = currentHeight;
                        }
                    });
                    $objects.height(height);
                });
            } else {
                var $objects = $context.find('.' + $toResize.attr("class").split(' ')[0]);
                $objects.height('');
            }
        } else if ($context.length > 0) {
            // console.log('"$toResize == undefined" dans giveSizeToOthers : '+$toResize.selector);
        }
    }
}

function giveSizeToOthersBis($context, $toResize, minWidth, maxWidth) {
    if ($context.length > 0) {
        if ($('.' + $toResize).length > 0) {
            if (!minWidth) var minWidth = 0; // compatibilité IE
            if (!maxWidth) var maxWidth = 9999; // compatibilité IE
            if (viewport().width > minWidth && viewport().width < maxWidth) {
                $context.each(function () {
                    var height = 0;
                    var $objects = $(this).find('.' + $toResize);

                    $objects.each(function () {
                        $objects.height('');
                        var currentHeight = $(this).outerHeight();

                        if (currentHeight > height) height = currentHeight;
                    });
                    if (height == 0) height = '';
                    $objects.outerHeight(height);
                });
            } else {
                $('.' + $toResize).height('');
            }
        }
    }
}

function giveCardsSameHeight(){
    giveSizeToOthersBis($('.RMO03'), 'service-title', 768);
    giveSizeToOthersBis($('.RMO03'), 'service-text', 768);
    giveSizeToOthersBis($('.RMO05'), 'job-title', 768);
    giveSizeToOthersBis($('.RMO05'), 'job-details', 768);
    giveSizeToOthersBis($('.RMO05'), 'job-text', 768);
    giveSizeToOthersBis($('.RMO19'), 'partner_logo', 480);
}

/**
 * @author Maxime Doré
 * @param string targetDiv	le hash vers lequel scroller la page (ex : "#content")
 * @param number offset		le offsetTop soustrait au scrollTop (ex : 100 scroll 100px plus haut)
 */
function scrollPage(targetDiv, offset) {
    if (!offset) var offset = $nav.height();

    if (!$body.hasClass('no-scroll') && $(targetDiv).length > 0) {
        window.scrollTo({
            top: $(targetDiv).offset().top - offset,
            behavior: 'smooth'
        });
        // $('html, body').clearQueue().stop().animate({
        //     scrollTop: $(targetDiv).offset().top - offset
        // }, 750);
    }
}

// Clear all form inputs
function clearForm($container) {
    $('input:not([type="submit"]):not([name="quantity"]):not([type="hidden"]), textarea', $container).val('').prop('checked', false).trigger('change');
    $('select', $container).val('').trigger('change');
}


// function filterPagination() {
//     if ($('.pagination_wrapper').length > 0) {
//         if ($pagination.htmlWrapper.length > 0 && $pagination.htmlContentWrapper.length > 0) {
//             $pagination.fetchAjaxInformationPagination(
//                 false,
//                 true,
//                 false
//             );
//         }
//     }
// }


// Detect IE
function isIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) { // If Internet Explorer, return version number
        return true;
    }

    return false;
}

function goBack(prev_url) {
    if (window.history.length > 1) {
        // Use history to change page
        window.history.go(-1);
    }
    if (!isIE()) {
        history_timeout = setTimeout(function () {
            //  Use previous URL as a fallback
            swup.loadPage({
                url: prev_url
            });
        }, 100)
    } else {
        // IE fallback
        window.location = prev_url;
    }
}

// Resize Fn
function onResize() {
    giveSizeToOthers($('.row--600'), $('.resized'), 600);
    giveSizeToOthers($('.row--768'), $('.resized'), 768);
    giveSizeToOthers($('.row--900'), $('.resized'), 900);
    giveSizeToOthers($('.row--1024'), $('.resized'), 1024);

    giveCardsSameHeight();

    $(window).trigger('scroll');
}
// Scroll Fn
function onScroll(e, posTop) {
    $(window).trigger('scroll');
    if (!$html.hasClass('is-animating')) {
        if (!posTop) posTop = $(window).scrollTop();

        if ($body.hasClass('no-scroll') == false) {
            if (posTop > 50) {
                $body.addClass('scroll');
            } else {
                $body.removeClass('scroll');
            }
        }

        // isInViewport for scroll animations and video autoplay
        $('.visible').each(function () {
            var $this = $(this);

            if ($this.is(':in-viewport()')) {
                $this.addClass('alive');
                // if (
                //     $this.is('video[autoplay][muted]') ||
                //     $this.is('video.active')
                // ) {
                //     this.play();
                // }
            } else if (!$this.hasClass('once')) {
                $this.removeClass('alive done');
                // if (
                //     $this.is('video[autoplay][muted]') ||
                //     $this.is('video.active')
                // ) {
                //     this.pause();
                // }
            }
        });
        // isInViewport for slick autoplay
        /*
        $('.slick-initialized').each(function () {
            var $this = $(this);

            if ($this.is(':in-viewport()')) {
                if ($this.hasClass('slick-initialized') && $this.slick('slickGetOption', 'autoplay')) {
                    $this.slick('slickPlay');

                }
            } else if (!$this.hasClass('once')) {
                if ($this.hasClass('slick-initialized') && $this.slick('slickGetOption', 'autoplay')) {

                   $this.slick('slickPause');
                }
            }
        });*/
        

        $('.slick-initialized').each(function () {
            var $this = $(this);
            if (!$this.slick('slickGetOption', 'autoplay')) return;

            // état interne pour éviter les appels répétés
            if ($this.data('playing') === undefined) {
                $this.data('playing', false);
            }

            if ($this.is(':in-viewport()')) {
                if ($this.hasClass('slick-initialized') && $this.slick('slickGetOption', 'autoplay')) {
    
                if (!$this.data('playing')) {
                    $this.slick('slickPlay');
                    $this.data('playing', true);
                }
            }
            } else if (!$this.hasClass('once')){
                if ($this.hasClass('slick-initialized') && $this.slick('slickGetOption', 'autoplay')) {

                if ($this.data('playing')) {
                    $this.slick('slickPause');
                    $this.data('playing', false);
                }
            }
            }
        });

        /*
        $('.slick-initialized').each(function () {
            var $this = $(this);
    
            // vérifier autoplay
            if (!$this.slick('slickGetOption', 'autoplay')) return;
    
            // état interne pour éviter les appels répétés
            if ($this.data('playing') === undefined) {
                $this.data('playing', false);
            }
    
            if ($this.is(':in-viewport()')) {
    
                if (!$this.data('playing')) {
                    $this.slick('slickPlay');
                    $this.data('playing', true);
                }
    
            } else {
    
                if ($this.data('playing')) {
                    $this.slick('slickPause');
                    $this.data('playing', false);
                }
    
            }
        });*/
        
    






    }
}


$(window).on('resize', $.throttle(100, onResize));
$(window).on('scroll', $.throttle(100, onScroll));
$(window).on('load', function () {
    $html.removeClass('is-animating');
    onLoad();
});
$(window).on('resetDOM', function () {
    if (typeof backgroundSetter === "function") {
        new backgroundSetter().init();
    }
    $(window).trigger('resize');
});





//////////////////////////////////////////////////////////////////////////
// Nouveau code 
//////////////////////////////////////////////////////////////////////////

// BURGER MENU
$('.hamburger, .menu').on('click', (e) => {
    if (
        e.target.classList.contains('has-sublinks') ||
        e.target.parentNode.classList.contains('has-sublinks') ||
        e.target.parentNode.parentNode.classList.contains('has-sublinks')
    ) return;
    toggleBurgerMenu();
});
$('.menu__wrapper').on('click', function(e){
    e.stopPropagation();
})

function toggleBurgerMenu() {
    $body.toggleClass('menu--shown');
    $menu.find('.active').removeClass('active');
    $menu.find('.scroll').animate({
        scrollTop: 0
    });
    // Reset menu subs
    $('.menu__dropdown + ul', $menu).clearQueue().stop().slideUp(250);
}

$menu_subs = $('.menu__dropdown', $menu);
$menu_subs.on('click', function () {
    let $this = $(this);
    $this.parent().siblings().removeClass('active').siblings('ul').clearQueue().stop().slideUp(400);
    $this.toggleClass('active').siblings('ul').clearQueue().stop().slideToggle(400);
});

// POPUPS
$(document).on('click', '.close-popup', function() {
    closePopup($(this).closest('.popup'));
});
$(document).on('keyup', function (e) {
    // Escape key
    if (e.keyCode === 27) {
        // Close the first visible popup
        if ($('.RGO18:visible').length) {
            closePopup($('.RGO18:visible').last());
        } else if ($('.RGO16:visible').length) {
            closePopup($('.RGO16:visible').last());
        } else if ($('.popup:visible').length) {
            closePopup($('.popup:visible').last());
        }
        // Close menu
        if ($body.hasClass('menu--shown')) toggleBurgerMenu();
        if ($body.hasClass('filters--shown')) $body.removeClass('filters--shown');
    }
});
function togglePopup(data) {
    let $popup = $('.popup[data-popup="' + data + '"]');
    closeAllPopups();
    $popup.stop().fadeToggle(500);
}
function closeAllPopups() {
    $('.popup').stop().fadeOut(500);
}
function closePopup($popup) {
    if (typeof $popup == 'undefined') $popup = $(this);

    $popup.stop().fadeOut(500, function () {
        if (typeof ($popup.attr('data-remove')) != 'undefined') {
            $(this).remove();
        }
    });
}
function closePopups() {
    $('.popup').stop().fadeOut(500, function () {
        if (typeof (popup.attr('data-remove')) != 'undefined') {
            this.remove();
        }
    });
}


/***** Navlinks dropdown menu ******/

// Giving attributes to each dropdown parent

let $nav_links = $('.has-sublink');
let $nav_sublinks = $('.dropdown__navlink');

// Opening background with height depending on wich submenu is needed
$('.has-sublink').hover(displaySublinkBackground, hideSublinkBackground);

function displaySublinkBackground() {

    let height = $(this).children('ul').outerHeight();

    $('.nav__sublinks-background').css('height', height);
    $('.nav__sublinks-background').css('transform', 'scaleY(1)');

}

function hideSublinkBackground() {
    $('.nav__sublinks-background').css('transform', 'scaleY(0)');
}

/***** Navlinks dropdown menu END ****** Mourad/
/***************************************/


function togglePlayMedia(media) {
    if (!media) return;
    if (media.classList.contains('active')) {
        media.classList.remove('active');
        media.pause();
    } else {
        media.classList.add('active');
        media.play();
    }
    togglePlayButtonMedia(media);
}

function togglePlayButtonMedia(media) {
    if (!media) return;
    $(media).closest('.section').find('.video__play').toggleClass('active', !media.paused);
}

function toggleSoundMedia(media) {
    if (!media) return;
    if (media.muted) {
        media.muted = false;
    } else {
        media.muted = true;
    }
    toggleSoundButtonMedia(media);
}

function toggleSoundButtonMedia(media) {
    if (!media) return;
    $(media).parent().find('.video__volume').toggleClass('active', !media.muted);
}


// RGO01-A - YouTube Iframe 
///////////////////////////////////////////////////////////////////////////
(function() {
    'use strict';
    
    let ytPlayers = new Map(); 
    let ytApiLoaded = false;
    let ytApiReady = false;

  
    function initYouTubePlayers() {
        const youtubeWidgets = document.querySelectorAll('.section .yt-player');
        
        if (youtubeWidgets.length === 0) return;
        
        // Charger l'API YouTube si nécessaire
        if (!ytApiLoaded) {
            ytApiLoaded = true;
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            script.async = true;
            script.onload = () => waitForAPI(); 
            document.body.appendChild(script);
        } else {
            waitForAPI();
        }

        function waitForAPI() {
            if (typeof YT !== 'undefined' && YT.Player) {
                ytApiReady = true;
                youtubeWidgets.forEach((iframe) => {
                    if (!iframe.dataset.ytInitialized) {
                        iframe.dataset.ytInitialized = 'true';
                        
                        const player = new YT.Player(iframe, {
                            events: {
                                'onReady': () => {
                                    ytPlayers.set(iframe, player);
                                    //console.log('YouTube player ready:', iframe.id || iframe.src);
                                },
                                'onStateChange': (event) => {
                                    handleYouTubeStateChange(event, iframe);
                                }
                            }
                        });
                    }
                });
            } else {
                setTimeout(waitForAPI, 100);
            }
        }
    }

    /**
     * Gérer les changements d'état YouTube
     */
    function handleYouTubeStateChange(event, iframe) {
        const section = iframe.closest('.section');
        if (!section) return;

        const widgetYoutube = section.querySelector('.widget--youtube');
        const playBtn = section.querySelector('.video__play');

        if (event.data === 1) { // Playing
            if (playBtn) playBtn.classList.add('active');
            if (widgetYoutube) widgetYoutube.style.opacity = '1';
        } else if (event.data === 2 || event.data === 0) { // Paused or Ended
            if (playBtn) playBtn.classList.remove('active');
           
        }
    }

   
    $body.on('click', '.section .video__play', function(e) {
        e.preventDefault();
        const section = $(this).closest('.section');
        const iframe = section.find('.yt-player')[0];
        if (!iframe || !ytApiReady) return;

        const player = ytPlayers.get(iframe);
        const widgetYoutube = section.find('.widget--youtube')[0];
        const btn = $(this);
        
        if (player && typeof player.playVideo === 'function') {
            const isActive = btn.hasClass('active');
            
            if (isActive) {
                player.pauseVideo();
                btn.removeClass('active');
                if (widgetYoutube) widgetYoutube.style.opacity = '0';
            } else {
                player.playVideo();
                btn.addClass('active');
                if (widgetYoutube) widgetYoutube.style.opacity = '1';
            }
        }
    });

    $body.on('click', '.section .video__volume', function(e) {
        e.preventDefault();
        const section = $(this).closest('.section');
        const iframe = section.find('.yt-player')[0];
        if (!iframe || !ytApiReady) return;

        const player = ytPlayers.get(iframe);
        const btn = $(this);
        
        if (player && typeof player.mute === 'function') {
            const isMuted = btn.hasClass('active');
            
            if (isMuted) {
                player.unMute();
                btn.removeClass('active');
            } else {
                player.mute();
                btn.addClass('active');
            }
        }
    });

    /**
     * Gestion du state change via l'API YouTube (pour synchronisation externe)
     */
    $body.on('youtube:sync', '.section .yt-player', function() {
        const iframe = this;
        const player = ytPlayers.get(iframe);
        if (!player) return;
        
        const state = player.getPlayerState();
        handleYouTubeStateChange({ data: state }, iframe);
    });

    // Initialisation au chargement du DOM
    $(document).ready(function() {
        initYouTubePlayers();
    });

    // Réinitialisation pour les chargements AJAX (SPA)
    $(window).on('resetDOM', function() {
        // Marquer tous les iframes comme non-initialisés
        document.querySelectorAll('.yt-player').forEach(iframe => {
            delete iframe.dataset.ytInitialized;
        });
        ytPlayers.clear();
        ytApiReady = false; // Forcer re-vérification de l'API
        initYouTubePlayers();
    });

    // Exposer onYouTubeIframeAPIReady globalement (requis par l'API YouTube)
    window.onYouTubeIframeAPIReady = function() {
        ytApiReady = true;
        initYouTubePlayers();
    };

})();